<template>
  <div>
    <p class="has-text-centered is-italic is-size-7 mt-3">
      All session fees include a sitting fee and digital images.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
